export enum Subject {
    Myself = "myself",
    Partner = "partner",
    Family = "family",
    Child = "child",
}
